
import { find, findIndex } from 'lodash';

export const MUTATE_CSV_FILES = 'MUTATE_CSV_FILES';
export const MUTATE_CSV_FILE = 'MUTATE_CSV_FILE';
export const ADD_CSV_FILE = 'ADD_CSV_FILE';
export const DELETE_CSV_FILE = 'DELETE_PRODUCT';
export const ADD_LOG_INFO = 'ADD_LOG_INFO';

export interface LogInfoPayload {
    csvUid: any;
    csvData: CSVData;
    logInfo: LogInfo;
}

export interface LogInfo {
    code?: string;
    message?: string;
}

export interface CSVLog {
    [csvDataId: string]: LogInfo;
}

export interface CSVLogs {
    [csvUid: string]: CSVLog;
}

export interface CSVData {
    id: any;
    [name: string]: string | number | boolean;
}

export interface CSVFile {
    uid: number | string;
    name: string;
    headers: string[];
    data: CSVData[];
    createdAt: string;
    updatedAt: string;
}

interface CSVStore {
    csvFiles: CSVFile[];
    csvLogs: CSVLogs;
}

// initial state
const productState: CSVStore = {
    csvFiles: [],
    csvLogs: {},
};

// getters
const getters = {
    getCSVs: (state: CSVStore) => state.csvFiles,
    getCSV: (state: CSVStore) => (name: string) => find(
        state.csvFiles, (csvFile: CSVFile) => csvFile.name === name,
    ),
};

// mutations
const mutations = {
    [MUTATE_CSV_FILES](state: CSVStore, payload: CSVFile[]) {
        state.csvFiles = payload;
    },
    [MUTATE_CSV_FILE](state: CSVStore, payload: CSVFile) {
        const index = findIndex(state.csvFiles, csvFile => csvFile.uid === payload.uid);
        if (index !== -1) state.csvFiles.splice(index, 1, payload);
    },
    [ADD_CSV_FILE](state: CSVStore, payload: CSVFile) {
        let index = 1;
        let counter = 0;
        const inputName = payload.name;

        // remove .csv extension from name
        const theNameWithoutExtension = inputName.substr(0, inputName.lastIndexOf('.')) || inputName;
        let theName = theNameWithoutExtension;

        const theIndex = (name: string) => findIndex(state.csvFiles, csvFile => csvFile.name === name);

        do {
            if (counter > 0) {
                theName = `${theNameWithoutExtension} (${counter})`;
            }
            counter += 1;
            index = theIndex(theName);
        } while (index !== -1);

        payload.name = theName;
        state.csvFiles.push(payload);
    },
    [DELETE_CSV_FILE](state: CSVStore, name: string) {
        const index = findIndex(state.csvFiles, csvFile => csvFile.name === name);
        state.csvFiles.splice(index, 1);
    },
    [ADD_LOG_INFO](state: CSVStore, payload: LogInfoPayload) {
        if (!state.csvLogs[payload.csvUid]) {
            // @ts-ignore
            this._vm.$set(state.csvLogs, payload.csvUid, {});
        }

        // @ts-ignore
        this._vm.$set(state.csvLogs[payload.csvUid], payload.csvData.id, payload.logInfo);
    },
};

// actions
const actions = {
    [MUTATE_CSV_FILES](context: any, payload: CSVFile[]) {
        context.commit(MUTATE_CSV_FILES, payload);
    },
    [ADD_CSV_FILE](context: any, payload: CSVFile) {
        context.commit(ADD_CSV_FILE, payload);
    },
};


export default {
    state: productState,
    getters,
    actions,
    mutations,
};
